import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { IonicModule } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NavBarModule } from './Components/nav-bar/nav-bar.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpRequestInterceptor } from './Services/http-interceptor/HttpRequestInterceptor';
import { StoreModule } from '@ngrx/store';
import { loginReducer } from './State/reducers/user.reducer';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { firstFilePartnerRegisterReducer } from './State/reducers/partner-files-register-reducers/first-file-partner-register.reducer';
import { secondFilePartnerRegisterReducer } from './State/reducers/partner-files-register-reducers/second-file-partner-register.reducer';
import { thirdFilePartnerRegisterReducer } from './State/reducers/partner-files-register-reducers/third-file-partner-register.reduce';
import { ToastErrorHandler } from './Services/error-handler/toast-error-handler.service';
import { RedirectAdminComponent } from './Routes/redirect-admin/redirect-admin.component';
import { RedirectAccountantComponent } from './Routes/redirect-accountant/redirect-accountant.component';
import { TranslocoRootModule } from './transloco-root.module';

@NgModule({
    declarations: [
        AppComponent,
        RedirectAdminComponent,
        RedirectAccountantComponent
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            rippleEffect: false,
            mode: 'ios'
        }),
        AppRoutingModule,
        NavBarModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            preventDuplicates: true,
        }),
        HttpClientModule,
        StoreModule.forRoot({
            login: loginReducer,
            firstFilePartnerRegister: firstFilePartnerRegisterReducer,
            secondFilePartnerRegister: secondFilePartnerRegisterReducer,
            thirdFilePartnerRegister: thirdFilePartnerRegisterReducer,
        }),
        MatIconModule,
        MatButtonModule,
        TranslocoRootModule,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestInterceptor,
            multi: true,
        },
        {
            provide: ErrorHandler,
            useClass: ToastErrorHandler,
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
